import {SearchProduct} from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import {useTranslations} from 'next-intl';
import {Button} from '../../../../../components/design-system';
import ScrollableList from '../../../../../components/design-system/ScrollableList';
import {ChevronLeft, ChevronRight} from '../../../../../components/icons';
import {Link} from '@/i18n/routing';
import ProductItem from '../../components/commons/ProductItem';

interface Props {
  loading?: boolean;
  products: SearchProduct[];
}

export default function RelatedProducts(props: Props) {
  const t = useTranslations('shop');

  function renderHeader({next, prev}: {next: () => void; prev: () => void}) {
    return (
      <div className="flex items-center justify-between mb-2 md:mb-3">
        <h4 className="font-bold text-2xl tracking-tighter text-greyscale-title m-0 p-0">
          {t('detail.related.title')}
        </h4>
        <div className="flex items-center shrink-0">
          <Button theme="ghost" palette="gray" onClick={prev}>
            <ChevronLeft className="h-5 -mx-1" />
          </Button>
          <Button theme="ghost" palette="gray" onClick={next}>
            <ChevronRight className="h-5 -mx-1" />
          </Button>
        </div>
      </div>
    );
  }

  return (
    <ScrollableList
      columns={{
        xxl: 5,
        xl: 5,
        lg: 4,
        md: 3,
        sm: 2,
        xs: 'auto',
      }}
      gap={8}
      data={props.products}
      keyExtractor={(product) => product.id}
      renderItem={(product) => (
        <Link
          key={product.id}
          href={{pathname: '/shop/[id]', params: {id: product.slug!}}}
          className="no-underline block h-full"
        >
          <ProductItem product={product} />
        </Link>
      )}
      renderHeader={renderHeader}
    />
  );
}
